// アプリケーション設定定数
export const APP_CONFIG = {
  // AI生成テンプレート関連
  AI_GENERATION: {
    MAX_TEMPLATES: 5, // AI生成テンプレートの最大数
  },

  // フォーマット自動挿入ルール関連
  FORMAT_INSERT_RULE: {
    MAX_NAME_LENGTH: 100, // ルール名の最大文字数
  },

  // ページネーション関連
  PAGINATION: {
    DEFAULT_PAGE_SIZE: 1000, // デフォルトページサイズ
  },
} as const
